module.exports = __webpack_public_path__ + "img/pl_Ecran 1.efafaec7.png";